module.exports = __webpack_public_path__ + "img/how-to-sell-apis-with-subscription-models-strategy.b5dffb8f.jpg";